export default {
  1: "Klanten",
  2: "Bankzaken",
  3: "Polissen",
  4: "Schade",
  5: "Hypotheken",
  6: "Mailing",
  7: "Dossiers",
  8: "Kredieten",
  9: "Inkomen",
  10: "Pensioen",
  11: "Kredieten",
  12: "Verplichtingen",
  14: "Kantoor",
  15: "Maatschappij",
  16: "Taken",
  17: "Klantportaal",
  18: "Portaal",
};
